var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UploadDocument", {
    attrs: {
      currentUserId: _vm.currentUserId,
      currentUser: _vm.currentUser,
      preventAutoUploading: "",
    },
    on: { fileUpdated: _vm.attachNewFile },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ addFile, removeFile, uploadFile, onDropFiles }) {
          return [
            _c("ModalFullScreen", {
              attrs: { size: "lg", title: _vm.applicationTitle },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "form",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex flex-col" },
                          [
                            _vm._t("default"),
                            _c("div", { staticClass: "mb-5" }, [
                              !_vm.newFile
                                ? _c("div", { staticClass: "text-label" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-4 text-primary-black text-sm customLineH mt-7",
                                      },
                                      [
                                        _vm._v(
                                          "Upload Resume or Cover letter :"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-center mb-1 rounded-sm border-dashed border border-gray-300 px-8 py-11",
                                        on: {
                                          drop: function ($event) {
                                            $event.preventDefault()
                                            return onDropFiles.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          dragover: function ($event) {
                                            $event.preventDefault()
                                          },
                                        },
                                      },
                                      [
                                        _c("UiButton", {
                                          staticClass: "b-attachment_document",
                                          attrs: {
                                            size: "no",
                                            buttonText: _vm.attachButtonText,
                                            variant: "outline",
                                            buttonClasses: "py-1 px-2 m-2",
                                          },
                                          on: { click: addFile },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "icon",
                                                fn: function () {
                                                  return [
                                                    _c("UploadIcon", {
                                                      staticClass: "w-3 h-3",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "hover-icon",
                                                fn: function () {
                                                  return [
                                                    _c("UploadIcon", {
                                                      staticClass: "w-3 h-3",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-sm text-storm-gray ml-1",
                                          },
                                          [_vm._v("or Drop Files")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "CardBodyItem",
                                        {
                                          attrs: {
                                            label: "Attached document",
                                            labelClass: "w-auto mr-2",
                                          },
                                        },
                                        [
                                          _c("AttachedDocument", {
                                            attrs: { name: _vm.newFile.name },
                                            on: { remove: removeFile },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c("ModalSectionsDivider"),
                        _c(
                          "div",
                          { staticClass: "flex pt-5 ml-auto" },
                          [
                            _c("UiButton", {
                              staticClass: "mr-4",
                              attrs: {
                                buttonText: "Cancel",
                                variant: "outline",
                                size: "lg",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                buttonText: _vm.actionButtonText,
                                disabled: false,
                                size: "lg",
                                variant: "black",
                                processing: _vm.processing,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.update(uploadFile)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }